import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-social-content-request-list',
  templateUrl: './social-content-request-list.component.html',
  styleUrls: ['./social-content-request-list.component.css'],
})
export class SocialContentRequestListComponent {
  url: string = 'socialContentRequests';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 50;

  modalTitle: string = '';
  modalContent: string | null = null;

  // Filters
  filters = {
    status: '',
    purpose: '',
    vertical: '',
    requested_by_type: '',
    platform: 'instagram',
  };

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    let queryParams = `?page=${this.currentPage}&limit=${this.itemsPerPage}&search=${this.searchText}`;

    if (this.filters.status) queryParams += `&status=${this.filters.status}`;
    if (this.filters.purpose) queryParams += `&purpose=${this.filters.purpose}`;
    if (this.filters.vertical)
      queryParams += `&vertical=${this.filters.vertical}`;
    if (this.filters.requested_by_type)
      queryParams += `&requested_by_type=${this.filters.requested_by_type}`;
    if (this.filters.platform)
      queryParams += `&platform=${this.filters.platform}`;

    this.dataService
      .getData(`${this.url}${queryParams}`)
      .subscribe((response) => {
        if (response && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getData();
  }

  resetFilters(): void {
    this.filters = {
      status: '',
      purpose: '',
      vertical: '',
      requested_by_type: '',
      platform: 'instagram',
    };
    this.applyFilters();
  }

  updateItemStatus(id: string, status: string): void {
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  generateAssets(id: string): void {
    if (!confirm('¿Desea generar los assets para este requerimiento?')) return;

    this.dataService
      .postData(`${this.url}/${id}/generate-assets`, {})
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.request_id && item.request_id.toLowerCase().includes(texto)) ||
          (item.notes && item.notes.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.request_id) sugerenciasSet.add(item.request_id);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
